<template>
  <div id="data-list-list-view" class="logistics-manage padTop32">
    <div class="filterWrap">
      <div class="filter-form">
        <gc-cmp-vs-input
          v-model="params.orderNo"
          class="filterInput"
          placeholder="请输入订单编号"
        />
        <gc-cmp-vs-input
          v-model="params.transitNo"
          class="filterInput"
          placeholder="请输入物流单号"
        />
        <!-- <v-date-select
          class="flatpickr-input date-picker"
          v-model="params.date"
          placeholder="请选择时间范围"
          :config="{ mode: 'range' }"
        /> -->

        <div class="date-wraper">
          <v-date-select
            style="width: 220px"
            class="flatpickr-input date-picker"
            v-model="params.date"
            placeholder="请选择时间范围"
            :config="{ mode: 'range', wrap: true }"
          />
          <div class="clear-btn" data-clear></div>
        </div>

        <!-- <v-select
          v-model="params.storehouse"
          :options="storehouseList"
          placeholder="请选择发货仓库"
          class="filterInput"
        >
          <div slot="no-options">暂无选项</div>
        </v-select> -->
        <!-- <gc-cmp-vs-input
          v-model="params.receiveAddress"
          class="filterInput"
          placeholder="请输入地址关键字"
        /> -->
        <div class="filter-select-input">
          <v-select
            v-model="paramsPersonType"
            :options="personTypeList"
            placeholder="买家/卖家"
            class="filterInput select-input"
          >
          </v-select>
          <gc-cmp-vs-input
            v-model="params.person"
            class="filterInput"
            placeholder="名称/编号"
          />
        </div>
        <vs-button @click="getTableData(1)">查询</vs-button>
      </div>
     <div v-if="filtering('logistics:export')" class="download-wrap marLeft20 pointer" @click.stop="exportData()">
        <vs-button class="down-btn" type="border" icon-pack="feather" icon="icon-download">下载全部</vs-button>
      </div>
    </div>
    <vs-table :data="tableData" noDataText="暂无数据">
      <template slot="thead">
        <vs-th
          v-for="(column, index) in columns"
          :key="index"
          :class="index === columns.length - 1 ? 'th-fixed' : ''"
        >
          {{ column.name }}
        </vs-th>
      </template>
      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <template v-for="(column, indextd) in columns">
              <vs-td v-if="indextd !== columns.length - 1" :key="indextd">
                <template v-if="!indextd">{{ indextr + 1 }}</template>
                <template v-else>{{ tr[column.key] }}</template>
              </vs-td>
            </template>
            <vs-td class="td-fixed">
              <vs-button
                v-if="tr['transitNo'] !== '-'&&filtering('logistics:detail')"
                type="flat"
                @click="showDetail(tr)"
                :style="{ padding: 'inherit' }"
                >查看物流明细</vs-button>
              <span v-else>--</span>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
    <!-- <gc-vs-pagination
        :total="pager.total"
        v-model="pager.page"
        :max-items="pager.size"
        :goto="true" class="marTop16"
      ></gc-vs-pagination> -->
      <gc-vs-pagination
        :pager="pager"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        ></gc-vs-pagination>
    <vs-prompt
      @cancel="rowInfo = {}"
      :title="detailData.expressName + '：' + detailData.transitNo"
      acceptText="确认"
      cancelText="取消"
      class="follow-detail"
      :active.sync="showDetailDialog"
    >
      <div class="timeline-wrapper">
        <div class="addressee">
          <div class="addressee-line"></div>
          <div class="addressee-item-point"><span>收</span></div>
          <div class="addressee-item-content">
            {{ detailData.receiveAddress || "[收货地址]" }}
          </div>
        </div>
        <template
          :v-if="detailData.traces.length > 0"
          v-for="(item, index) in detailData.traces"
        >
          <vx-timeline
            :showLine="index !== detailData.traces.length - 1"
            :key="index"
            :timer="{
              date: getTime('day', item.time),
              time: getTime('time', item.time),
            }"
            :title="item.state"
            :message="item.trace"
          />
        </template>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import GcCmpVsInput from "@/group-cloud/components/vsInput";
import GcCmpVsTable from "@/group-cloud/components/vsTable";
import { LogisticsApi } from "@/modules/server-api/commodity-sys/logistics";
import { WmsSupplierApi } from "@/modules/server-api/wms-manage/supplier";
import { downloadExcel } from '@/utils/downloadExcel.js';
const columnFixedStyle = {
  th: {
    position: "sticky !important",
    zIndex: 2,
    right: "0px",
    background: "#f3f2f7",
    boxShadow: "-5px 0 10px -5px rgba(0, 0, 0, 0.15)",
  },
  td: {
    position: "sticky !important",
    zIndex: 2,
    right: "0px",
    background: "#fff",
    boxShadow: "-5px 0 10px -5px rgba(0, 0, 0, 0.15)",
  },
};
export default {
  data() {
    return {
      params: {},
      paramsPersonType: "",
      editPageUrl: "/modules/logistics/manage/edit",
      storehouseList: [
        { code: 1, label: "发货仓库1" },
        { code: 2, label: "发货仓库2" },
      ],
      personTypeList: [
        { code: "buy", label: "买家" },
        { code: "sale", label: "卖家" },
      ],
      columns: [
        {
          name: "序号",
          width: "60px",
          key: "index",
        },
        {
          name: "订单编号",
          key: "orderNo",
          width: "180px",
        },
        {
          name: "订单日期",
          key: "orderDate",
          width: "110px",
        },
        {
          name: "订单状态",
          key: "orderStatus",
        },
        {
          name: "卖家编号",
          key: "seller",
        },
        {
          name: "卖家名称",
          key: "sellerName",
        },
        {
          name: "买家编号",
          key: "buyer",
        },
        {
          name: "买家名称",
          key: "buyerName",
        },
        {
          name: "发货仓",
          key: "sendWs",
        },
        {
          name: "收货地址",
          key: "receiveAddress",
        },
        {
          name: "物流商",
          key: "expressName",
        },
        {
          name: "发货日期",
          key: "sendDate",
          width: "110px",
        },
        {
          name: "物流单号",
          key: "transitNo",
        },
        // {
        //   name: "物流状态",
        //   key: "transitStatus",
        // },
        {
          name: "操作",
          width: "120px",
          key: "handle",
        },
      ],
      tableData: [],
      detailData: {},
      showDetailDialog: false,
      rowInfo: {},
      pager: {
        page: 1,
        size: 20,
        total: 0
      }
    };
  },
  components: {
    GcCmpVsInput,
    GcCmpVsTable,
  },
  created() {
    this.getStorehouseList();
    this.getTableData();
  },
  methods: {
    getColumnStyle(type, column) {
      let style = {};
      if (column?.width) {
        style.width = column.width;
      }
      if (column?.fixed && column.fixed === "right") {
        console.log(type);
        console.log(columnFixedStyle[type]);
        Object.assign(style, columnFixedStyle[type]);
      }
      return style;
    },
    async getStorehouseList() {
      let resp = await LogisticsApi.getStorehouseList({
        suggest: "",
        type: "DIST",
      });
      let result = resp.result;
      let data = [];
      if (result && result.length) {
        result.forEach((item) => {
          let { wsId, wsCode, wsName } = item;
          data.push({ id: wsId, label: wsName });
        });
      }
      this.storehouseList = data;
    },
    async getDetail(row) {
      let { transitNo, expressCode, orderNo } = row;
      console.log(row);
      let resp = await LogisticsApi.getFollowDetail({
        transitNo,
        express: expressCode,
        orderNo
      });
      this.detailData = resp.result || {
        expressName: "",
        transitNo: "",
        receiveAddress: "",
        traces: [],
      };
      console.log(this.detailData);
    },
    async getTableData(page) {
      if (page) this.pager.page = page;
      let { orderNo, date, storehouse, person, transitNo } = this.params;
      let data = { orderNo };
      if (date) {
        let arr = date.split(" 至 ");
        data.startDate = arr[0];
        data.endDate = arr[1];
        if (!data.endDate) {
          data.endDate = data.startDate
        }
      }
      if (storehouse) {
        data.wsId = storehouse.id;
      }
      if (transitNo) {
        data.transitNo = transitNo;
      }
      if (person) {
        let type = this.paramsPersonType.code;
        if (!type || (type && type !== "buy")) {
          data.seller = person;
          this.paramsPersonType = { code: "sale", label: "卖家" };
        } else {
          data.buyer = person;
        }
      }
      this.$vs.loading();
      this.tableData = [];
      let resp = await LogisticsApi.getFollowList({
        pageNo: this.pager.page,
        pageSize: this.pager.size,
        data: data
      });
      this.$vs.loading.close();
      this.tableData = resp.result.list;
      let resCount = resp.result.totalCount;
      //resCount = Math.ceil(resCount / this.pager.size);
      this.pager.total = resCount;
      this.$vs.loading.close();
    },
    //分页
    // async changePage(payload) {
    //   this.pager.page = payload.page || 1;
    //   return await this.getTableData();
    // },
    //导出
    async exportData() {
      //组装下载参数
      let { orderNo, date, storehouse, person } = this.params;
      let data = { orderNo };
      if (date) {
        let arr = date.split(" 至 ");
        data.startDate = arr[0];
        data.endDate = arr[1];
        if (!data.endDate) {
          data.endDate = data.startDate
        }
      }
      if (storehouse) {
        data.wsId = storehouse.id;
      }
      if (person) {
        let type = this.paramsPersonType.code;
        if (!type || (type && type !== "buy")) {
          data.seller = person;
          this.paramsPersonType = { code: "sale", label: "卖家" };
        } else {
          data.buyer = person;
        }
      }
      console.log("===data===", data);
      let param = {
        data: data,
        pageNo: 1,
        pageSize: 99999
      }
      let url = '/data-dist/api/dist/tms/express/orders/export';
      let fileName = '物流跟踪.xlsx';
      downloadExcel(url, param, fileName);
    },
    showDetail(row) {
      this.showDetailDialog = true;
      this.getDetail(row);
    },
    getTime(type, value) {
      let arr = value.split(" ");
      return type === "day" ? arr[0] : arr[1];
    },
    //更改每页条数
    handleSizeChange(val){
      this.pager.size = val;
      this.getTableData();
    },
    handleCurrentChange(val){
      this.pager.page = val;
      this.getTableData();
    }
  },
  watch:{
    // 'pager.page'() {
    //  this.getTableData();
    // }
  }
};
</script>

<style lang="scss" scoped>
@import "@/modules/commodity-sys/commodity.scss";
.logistics-manage {
  ::v-deep .vs-table {
    width: 1500px;
    min-width: 100%;
    table-layout: fixed;
    thead th {
      white-space: nowrap;
    }
    td {
      word-break: break-all;
    }
    .td-fixed {
      width: 250px;
      position: sticky;
      right: 0;
      background-color: #fff;
      box-shadow: -2px 0 2px rgba(0, 0, 0, 0.02);
    }
    .th-fixed {
      position: sticky;
      right: 0;
      background-color: #f3f2f7;
      box-shadow: -2px 0 2px rgba(0, 0, 0, 0.02);
    }
  }
  .filter-form {
    display: flex;
    max-width: calc(100% - 88px);
    .filterInput {
      width: 130px;
      margin-right: 6px;
      ::v-deep .vs__selected {
        white-space: nowrap;
      }
    }

    .filter-select-input {
      display: flex;
      .filterInput:first-child {
        width: 100px;
        margin-right: 0px;
        ::v-deep .vs__dropdown-toggle {
          border-right: 0px;
          border-radius: 4px 0 0 4px;
        }
      }
      .filterInput {
        width: 110px;
        ::v-deep input {
          border-radius: 0 4px 4px 0;
        }
      }
    }
  }
  .date-picker {
    width: 188px;
    height: 37.2px;
    margin-right: 6px;
    &::placeholder {
      font-size: 12px;
      color: rgba(0, 0, 0, 0.35);
    }
  }
}
.follow-detail {
  .timeline-wrapper {
    width: 80%;
    margin: 0 auto;
    padding-top: 10px;
    max-height: 400px;
    overflow-y: auto;
    .addressee {
      display: flex;
      width: 80%;
      min-height: 50px;
      padding: 0 1.5rem 1rem 1.5rem;
      position: relative;
      left: 20%;
      .addressee-line {
        position: absolute;
        top: 5px;
        left: 0;
        width: 1px;
        height: 100%;
        background: #ebe9f1;
      }
      .addressee-item-point {
        position: absolute;
        width: 20px;
        height: 20px;
        top: 0px;
        z-index: 1;
        left: -10px;
        text-align: center;
        border-radius: 50%;
        background-color: rgb(64, 144, 255);
        span {
          text-align: center;
          font-size: 12px;
          line-height: 20px;
          color: #fff;
        }
      }
      .addressee-item-content {
        font-size: 12px;
      }
    }
  }
  footer {
    display: none;
  }
}

.date-wraper{
  position: relative;
  input::-webkit-input-placeholder{
    font-size: 12px;
    color: rgba(0, 0, 0, 0.4);
  }
  .clear-btn{
    width: 18px;
    height: 18px;
    position: absolute;
    right: 18px;
    top: 50%;
    transform: translateY(-50%);
    background: url(https://hidataqrcode.oss-cn-hangzhou.aliyuncs.com/887933012174442496.png?Expires=1931087022&OSSAccessKeyId=LTAI5xyIqe4GhOvC&Signature=9JshiSjzm1p0o%2FkZYeyT9i7sw9E%3D) no-repeat;
    background-size: 100%;
  }
}
</style>
